import { render } from "./vote-receipt.vue?vue&type=template&id=1de287d2"
import script from "./vote-receipt.vue?vue&type=script&lang=js"
export * from "./vote-receipt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__